import { useTranslation } from "react-i18next"
import { memo } from "react"
import Callout from "components/callout/callout"
import Section from "../layout/section"

interface FormErrorsInterface {
    errors: string[]
}

const FormErrors: React.FC<FormErrorsInterface> = ({ errors }) => {

    const { t } = useTranslation()

    if (errors.length === 0) {
        return null
    }

    console.log(errors)

    return (
        <>
            {errors.map((error, index) => (
                <Callout type="error" key={index}>{t(error)}</Callout>
            ))}
        </>
    )
}

export default memo(FormErrors)

